import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    questions: [
      {
        field: 'Prc_LeadershipFirm',
        title: 'Leadership of the Firm',
        question:
                'Please tell us the extent to which you agree with the following statements about {EvaluateeFullName}.',
        drivers: [
          { field: 'Prc_Leadership_Firm_RoleModel', question: 'Is seen as an ambassador for what makes the firm great / regarded as a role model.' },
          { field: 'Prc_Leadership_Firm_GoodToWorkWith', question: 'Creates an inclusive environment on projects and embraces diverse perspectives.' },
          { field: 'Prc_Leadership_Firm_Solidarity', question: 'Fosters unity of action on projects and across the firm (Solidarity).' },
          { field: 'Prc_Leadership_Firm_Boldness', question: 'Willing to take risks and act innovatively; Demonstrates courage of conviction with clients (Boldness).' },
          { field: 'Prc_Leadership_Firm_Curiosity', question: 'Shows a strong desire to tune into market innovations, develop new thinking, develop self-awareness (Curiosity).' },
          { field: 'Prc_Leadership_Firm_Generosity', question: 'Gives space to others to act and decide, the information needed to do the job successfully, as well as permission to make mistakes (Generosity).' },
          { field: 'Prc_Leadership_Firm_Passion', question: 'Shows enthusiasm for people and the task at hand (Passion).' },
        ],
        verbatim: {
          field: 'Prc_Leadership_Firm_Verbatim',
        },
      },
      {
        field: 'Prc_LeadershipPeople',
        title: 'Leadership of our People',
        question:
            'Please tell us the extent to which you agree with the following statements about yourself.',
        drivers: [
          { field: 'Prc_Leadership_People_Mentor', question: 'Mentors and develops people.' },
          { field: 'Prc_Leadership_People_Collaboration', question: 'Collaborates effectively.' },
          { field: 'Prc_Leadership_People_GoodLearner', question: 'Is self-aware, listens and learns from others.' },
          { field: 'Prc_Leadership_People_Followership', question: 'Has a followership within the firm.' },
          { field: 'Prc_Leadership_People_BuildsCulture', question: 'Builds a culture of success, engagement and learning.' },
        ],
        verbatim: {
          field: 'Prc_Leadership_People_Verbatim',
        },
      },
      {
        field: 'Prc_LeadershipClient',
        title: 'Client Portfolio, Innovation and Relationship Development',
        question:
            'Please tell us the extent to which you agree with the following statements about yourself.',
        drivers: [
          { field: 'Prc_Leadership_Client_Relationships', question: 'Systematically deepens and expands client and broader business relationships.' },
          { field: 'Prc_Leadership_Client_TrustedAdvisor', question: 'Is seen as a ‘trusted advisor’', example: '(by clients and / or people within the firm).' },
          { field: 'Prc_Leadership_Client_BestOfFirm', question: 'Brings the ‘best of firm’ to clients.' },
          { field: 'Prc_Leadership_Client_PositivePersonalBrand', question: 'Has a positive and distinctive personal brand.' },
          { field: 'Prc_Leadership_Client_Platform', question: 'Has created a commercial platform that is clear and compelling.' },
          { field: 'Prc_Leadership_Client_Entrepreneurial', question: 'Brings forward-thinking ideas and entrepreneurial energy.' },
          { field: 'Prc_Leadership_Client_BusinessOwner', question: 'Thinks like a business owner', example: '(for example, assumes ultimate accountability, is a steward of firm culture, takes a long-term view).' },
        ],
        verbatim: {
          field: 'Prc_Leadership_Client_Verbatim',
        },
      },
      {
        field: 'Mgr_Client',
        title: 'Client & Business Development',
        question:
            'Please tell us the extent to which you agree with the following statements about yourself.',
        drivers: [
          { field: 'Mgr_Client_DevelopedCommercialPlatform', question: 'Has developed a clearly defined commercial platform which is aligned with the practice and unit.' },
          { field: 'Mgr_Client_DevelopedPersonalBrand', question: 'Has developed an attractive personal brand inside and outside of the firm.' },
          { field: 'Mgr_Client_Relationships', question: 'Demonstrates sustained client relationships beyond current engagement.' },
          { field: 'Mgr_Client_GoodCouncil', question: 'Clients seek their counsel and advice.' },
          { field: 'Mgr_Client_PursuesNewBusiness', question: 'Proactively identifies and pursues new business opportunities with others.' },
        ],
        verbatim: {
          field: 'Mgr_Client_Verbatim',
        },
      },
      {
        field: 'Mgr_Leadership',
        title: 'Leadership & People',
        question:
            'Please tell us the extent to which you agree with the following statements about yourself.',
        drivers: [
          { field: 'Mgr_Leadership_Followership', question: 'An authentic leader who is building followership.' },
          { field: 'Mgr_Leadership_Interactions', question: 'Inclusive & respectful in all interactions.' },
          { field: 'Mgr_Leadership_commitment', question: 'Shows commitment to activities such as recruiting, mentoring, team building, etc.' },
          { field: 'Mgr_Leadership_HelpImproveOthers', question: 'Uses coaching and feedback day to day to unlock the potential of others.' },
          { field: 'Mgr_Leadership_SeenAsAmbassador', question: 'Is seen as an ambassador and exemplar of what makes the firm great.' },
        ],
        verbatim: {
          field: 'Mgr_Leadershipt_Verbatim',
        },
      },
      {
        field: 'Mgr_Innovation',
        title: 'Ideas & Innovation',
        question:
            'Please tell us the extent to which you agree with the following statements about yourself.',
        drivers: [
          { field: 'Mgr_Innovation_Followership', question: 'Develops knowledge/IC that is being used by the practice to win/execute engagements.' },
          { field: 'Mgr_Innovation_Interactions', question: 'Fosters creativity and innovation.' },
          { field: 'Mgr_Innovation_commitment', question: 'Brings differentiated thinking to proposals and engagements.' },
        ],
        verbatim: {
          field: 'Mgr_Innovation_Verbatim',
        },
      },
    ],
    optout: {
      field: 'Optout_Reason',
      title: 'Decline Request',
      question:
            'Please provide your reason for declining the request for feedback',
      options: [
        'Lack of relevant exposure',
        'Feedback provided through different channel',
        'Other',
      ],
      verbatim: {
        field: 'Optout_Reason_Other',
        question: 'Please specify',
      },
    },
    skip: {
      field: 'Skip_Reason',
      title: 'Are you sure you want to skip this section?',
      text: 'None of the answers in this section will be recorded if you skip the section',
      question:
          'Please provide your reason',
      options: [
        'Lack of relevant exposure',
        'Other',
      ],
      verbatim: {
        field: 'Skip_Reason_Other',
        question: 'Please specify',
      },
    },
    params: 'Init',
    response: {
      currentStep: 1,
    },
    surveyFlow: {
      principal_self: ['Intro', 'Prc_LeadershipFirm', 'Prc_LeadershipPeople', 'Prc_LeadershipClient', 'Summary', 'Nominate', 'SurveyEnd'],
      manager_self: ['Intro', 'Mgr_Client', 'Mgr_Leadership', 'Mgr_Innovation', 'Summary', 'Nominate', 'SurveyEnd'],
      principal_peer: ['Intro', 'Prc_LeadershipFirm', 'Prc_LeadershipPeople', 'Prc_LeadershipClient', 'Summary', 'SurveyEnd'],
      manager_peer: ['Intro', 'Mgr_Client', 'Mgr_Leadership', 'Mgr_Innovation', 'Summary', 'SurveyEnd'],
    },
  },
  mutations: {
    storeResponse(state, r) {
      state.response[r.k] = r.v;
    },
    setParams(state, paramsFromContext) {
      state.params = paramsFromContext;
    },
    setCurrentStep(state) {
      state.response.currentStep += 1;
    },
    incrementCurrentStep(state) {
      state.responseCommited = JSON.parse(JSON.stringify(state.response));
      state.responseCommited.currentStep += 1;
      state.response = JSON.parse(JSON.stringify(state.response));
      state.response.currentStep += 1;
    },
    completeSurvey(state) {
      state.responseCommited = JSON.parse(JSON.stringify(state.response));
      state.responseCommited.isCompleted = true;
      state.response = JSON.parse(JSON.stringify(state.response));
      state.response.isCompleted = true;
    },
    previousPage(state, stepNumber) {
      state.responseCommited = JSON.parse(JSON.stringify(state.response));
      state.previousStep = state.responseCommited.currentStep;
      state.responseCommited.currentStep = stepNumber;
      state.response = JSON.parse(JSON.stringify(state.response));
      state.response.currentStep = stepNumber;
    },
  },
  actions: {
    storeResponse({ state }) {
      axios.post('api/response/store', state.responseCommited);
    },
  },
  getters: {
    currentStep(state) {
      return state.response.currentStep;
    },
    surveyFlow(state) {
      let flow = state.params.SurveyType;
      flow = flow.concat('_');
      flow = flow.concat(state.params.EvaluatorRelativePosition);
      return state.surveyFlow[flow.toLowerCase()];
    },
    isSelfSurvey(state) {
      if (state.params.SurveyType) {
        return state.params.EvaluatorRelativePosition.toLowerCase() === 'self';
      }
      return false;
    },
    surveyType(state) {
      if (state.params.SurveyType) {
        return state.params.SurveyType.toLowerCase();
      }
      return false;
    },
    isOptedOut(state) {
      return state.response.IsOptedOut;
    },
  },
  modules: {},
});
